var dirpaths = require('./lib/paths');

Object.assign(exports, dirpaths)
exports.readFiles = require('./lib/readfiles');
exports.readFilesStream = require('./lib/readfilesstream');



//////////////////
// WEBPACK FOOTER
// ./~/node-dir/index.js
// module id = 958
// module chunks = 0 1